import TRANSLATION_ACCESSIBILITY_TR from './accessibility/translation';
import TRANSLATION_BOOKING_TR from './booking/translation';
import TRANSLATION_EVENTS_TR from './events/translation';
import TRANSLATION_EXPERIENCES_TR from './experiences/translation';
import TRANSLATION_FORM_TR from './form/translation';
import TRANSLATION_LANDING_PAGES_TR from './landingPages/translation';
import TRANSLATION_RESERVE_TR from './reserve/translation';
import TRANSLATION_SIGNIN_TR from './signin/translation';
import TRANSLATION_DATES_TR from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_TR,
  ...TRANSLATION_BOOKING_TR,
  ...TRANSLATION_DATES_TR,
  ...TRANSLATION_EVENTS_TR,
  ...TRANSLATION_EXPERIENCES_TR,
  ...TRANSLATION_FORM_TR,
  ...TRANSLATION_LANDING_PAGES_TR,
  ...TRANSLATION_RESERVE_TR,
  ...TRANSLATION_SIGNIN_TR,
};
